<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row pt-2 pb-4>
          <v-col shrink>
            <span
              class="pl-3 font-weight-regular font-size--24 text-white"
              role="heading"
              aria-level="1"
              >{{ $t('L_help_title') }}</span
            >
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <template>
          <v-card class="mb-4">
            <v-card-text>
              <v-row class="help-frame mb-4">
                <iframe
                  @load="globalStore.rootLoading = false"
                  id="mainIframe"
                  width="100%"
                  height="580px"
                  frameborder="0"
                  scrolling="auto"
                  align="left"
                  :title="$t('L_help_iframe_title')"
                  marginwidth="0"
                  marginheight="0"
                  :seamless="true"
                  :src="frameSource"
                />
              </v-row>
              <v-row class="help-footer text-center">
                <v-col cols="12" class="flex-footer">
                  <v-expansion-panel class="pri-center-expansion-panel" role="presentation">
                    <v-expansion-panel-text role="presentation" tabindex="-1">
                      <template>
                        <div
                          ref="options1"
                          role="button"
                          :aria-expanded="`${!!expanded}`"
                          @click="expanded = !expanded"
                          tabindex="0"
                        >
                          {{ $t('L_more_support_options') }}
                        </div>
                      </template>
                      <v-divider />
                      <v-card>
                        <v-row justify="space-around" class="text-center font-size--14">
                          <v-col cols="12" sm="4" md="3" pt-2>
                            <v-row justify="center" pt-4 pb-4>
                              <v-col cols="2">
                                <v-icon color="primary"> phone </v-icon>
                              </v-col>
                              <v-col shrink class="font-weight-medium">
                                {{ $t('L_call_support') }}
                              </v-col>
                              <v-col cols="8" pl-4>
                                <a
                                  id="help_call_support"
                                  :href="'tel:1' + contact.number"
                                  class="font-weight-medium cobalt"
                                  >{{ contact.phone }}</a
                                >
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" sm="4" md="3" pt-2>
                            <v-row justify="center" pt-4 pb-4>
                              <v-col cols="2">
                                <v-icon color="primary"> mail_outline </v-icon>
                              </v-col>
                              <v-col shrink class="font-weight-medium">
                                {{ $t('L_email_support') }}
                              </v-col>
                              <v-col cols="12">
                                <a id="help_email_support" :href="'mailto:' + contact.email">{{
                                  contact.email
                                }}</a>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" sm="4" md="3" pt-2>
                            <v-row pt-4 pb-4>
                              <v-col cols="12" mb-2 class="font-weight-medium">
                                {{ $t('L_hours_of_operation') }}
                              </v-col>
                              <v-col cols="12" class="font-size--12">
                                {{ $t('L_monday_to_friday_hours') }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { mapStores } from 'pinia';

export const contactInfo = [
  { number: 8002574725, phone: '(800) 257-4725', email: 'plic@primerica.com' },
  { number: 8002574725, phone: '(800) 257-4725', email: 'nblic@primerica.com' },
  { number: 8003877976, phone: '(800) 387-7976', email: 'plicc_cn@primerica.com' },
];

const componentOptions: ComponentOptions = {
  name: 'HelpComponent',
  data: () => ({
    frameSource: window.appConfig.help.anonymous,
    expanded: false,
  }),
  computed: {
    ...mapStores(useGlobalStore, usePolicyStore),
    contact() {
      if (this.policyStore.currentPolicy?.isCanadaPolicy) {
        return contactInfo[2];
      } else if (this.policyStore.currentPolicy?.isNewYorkPolicy) {
        return contactInfo[1];
      } else {
        return contactInfo[0];
      }
    },
  },
  mounted() {
    if (this.$route.params.type) {
      this.frameSource = `${window.appConfig.help[this.$route.params.type as string]}`;
    }
    this.globalStore.rootLoading = true;
    if (this.policyStore.policies.length > 0 && this.policyStore.policies[0].contractId === '0') {
      this.policyStore.getPolicyOverview();
    }
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
#mainIframe {
  overflow-y: scroll;
}
</style>
